export const closestParent = function(elem, selector) {
  for (; elem && elem !== document; elem = elem.parentNode) {
    if (elem.matches(selector)) return elem
  }
  return null
}

export const isPrintableCharacter = str => {
  return str.length === 1 && str.match(/\S/)
}

export const setSubmenuFocusToLastMenuItem = submenu => {
  const menuItems = submenu.querySelectorAll("a[role='menuitem']")
  const lastElement = menuItems[menuItems.length - 1]

  if (lastElement) {
    lastElement.focus()
  }
}

export const setSubmenuFocusToFirstMenuItem = submenu => {
  const menuItems = submenu.querySelectorAll("a[role='menuitem']")
  const firstElement = menuItems[0]

  if (firstElement && firstElement.offsetParent !== null) {
    firstElement.focus()
  } else {
    let first = menuItems[0]
    let count = 0

    while (first && first.offsetParent === null) {
      count++
      first = menuItems[count]
    }

    if (first) {
      first.focus()
    }
  }
}

export const setSubmenuFocusToNextMenuItem = submenu => {
  const current = document.activeElement
  const links = [...submenu.querySelectorAll("a[role='menuitem']")]

  let next = null
  let count = 0

  if (current === links[links.length - 1]) {
    next = links[count]
  } else {
    const index = links.findIndex(l => l === current)

    count = index + 1
    next = links[count]
  }

  while (next && next.offsetParent === null) {
    count++
    next = links[count]
  }

  if (next) {
    next.focus()
  }
}

export const setSubmenuFocusToPreviousMenuItem = submenu => {
  const current = document.activeElement
  const links = [...submenu.querySelectorAll("a[role='menuitem']")]

  let prev = null
  let count = links.length - 1

  if (current === links[0]) {
    prev = links[count]
  } else {
    const index = links.findIndex(l => l === current)

    count = index - 1
    prev = links[count]
  }

  while (prev && prev.offsetParent === null) {
    prev = links[count]
    count--
  }

  if (window.matchMedia("(max-width: 991px)").matches && count < 0) {
    prev = links[links.length - 1]
  }

  if (prev) {
    prev.focus()
  }
}

export const setSubmenuFocusByMenuItemFirstCharacter = (submenu, char) => {
  const links = [...submenu.querySelectorAll("a[role='menuitem']")]
  const index = links.find(l => {
    return (
      l.textContent
        .trim()
        .toLowerCase()
        .substring(0, 1) === char.toLowerCase()
    )
  })

  if (index) {
    index.focus()
  }
}
